

































































































































































































































import Vue from 'vue'
import CheckoutService from '@/services/CheckoutService'
import StripeCardElement from './StripeCardElement.vue'
import { currency } from '@/helper/constants'
import UISpinner from '@/components/common/UISpinner.vue'
import { UpsellOfferType } from '@/models/UpsellOffer'
import BaseIcon from '@/components/svgicons/BaseIcon.vue'

export default Vue.extend({
  components: { StripeCardElement, UISpinner, BaseIcon },
  name: 'PaymentModal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    location: Object,
    contact: Object,
    locationId: String,
    offerId: String,
    checkoutSource: String,
    showThankYouMsg: Boolean,
    freeProduct: Boolean,
    offer: Object,
    isUpsell: {
      type: Boolean,
      default: false
    },
    upsellType: {
      type: String,
      default: null
    },
    paymentMethods: {
      type: Array,
      default: null
    }
  },
  data() {
    currency
    return {
      currency,
      stripeAPIToken: '',
      stripe: {} as any,
      stripeElements: {} as any,
      elements: {} as any,
      card: {} as any,
      errMsg: '',
      disableCheckoutBtn: false,
      openModal: false,
      chargeCardType: 'newCard',
      selectedSavedCard: ''
    }
  },
  computed: {
    isInAppUpsell(): boolean {
      return this.upsellType ? this.upsellType === UpsellOfferType.INAPP : false
    }
  },
  async mounted() {
    this.stripeAPIToken = this.location.stripe
    this.openModal = this.showModal
    if (this.paymentMethods?.length) {
      this.chargeCardType = 'savedCards'
    }
  },
  methods: {
    getCardIcon(type: string) {
      switch (type) {
        case 'amex':
          return require('@/assets/cards/amex.svg')
        case 'diners':
          return require('@/assets/cards/diners.svg')
        case 'discover':
          return require('@/assets/cards/discover.svg')
        case 'mastercard':
          return require('@/assets/cards/mastercard.svg')
        case 'unionpay':
          return require('@/assets/cards/unionpay.svg')
        case 'visa':
          return require('@/assets/cards/visa.svg')
        default:
          return require('@/assets/cards/card.svg')
      }
    },
    async purchase() {
      try {
        this.disableCheckoutBtn = true

        const { data: setupIntentResponse } = await CheckoutService.setupIntent(
          {
            locationId: this.locationId,
            offerId: this.offerId
          }
        )

        const {
          client_secret: clientSecret,
          payment_method: setupIntentPaymentMethod
        } = setupIntentResponse

        if (!clientSecret) {
          throw new Error(
            'Client secret missing! Payment setup failed, try again!'
          )
        }

        let paymentMethod
        let isNewCard = true
        let stripeCustomerId

        if (this.chargeCardType === 'savedCards') {
          paymentMethod = this.selectedSavedCard
          isNewCard = false
          stripeCustomerId = this.contact.stripeCustomerId
        } else {
          if (setupIntentPaymentMethod) {
            paymentMethod = setupIntentPaymentMethod
          }

          const cardNumber = this.stripeElements.getElement('cardNumber')

          const result = await this.stripe.confirmCardSetup(clientSecret, {
            payment_method: {
              type: 'card',
              card: cardNumber,
              billing_details: {
                name:
                  this.contact.full_name_lower_case || this.contact.first_name
              }
            }
          })

          if (result.error) {
            throw new Error(result.error.message)
          }

          if (result.setupIntent) {
            paymentMethod = result.setupIntent.payment_method
          }
        }

        const payload = {
          fingerprint: this.contact.fingerprint,
          locationId: this.contact.location_id,
          productType: 'offer',
          paymentMethodId: paymentMethod,
          clientSecret,
          checkoutSource: this.checkoutSource,
          checkoutType: 'purchase',
          isNewCard: isNewCard,
          stripeCustomerId: stripeCustomerId
        }

        try {
          const {
            data: { ct, previewUrl, upsellOfferId, featureFlag }
          } = await CheckoutService.checkout(this.offerId, payload)
          this.$emit('order-successful', {
            ct,
            previewUrl,
            upsellOfferId,
            featureFlag,
            closeModal: this.isInAppUpsell ? true : false
          })
          this.disableCheckoutBtn = false
          // if (this.isInAppUpsell) {
          //   setTimeout(() => {
          //     window.close()
          //   }, 5000)
          // }
        } catch (err) {
          throw new Error(err?.response?.data?.msg)
        }
      } catch (error) {
        this.errMsg = error
        this.disableCheckoutBtn = false
      }
    },
    closeModal() {
      this.$emit('close')
    },
    selectSavedCard(payload: string) {
      this.errMsg = ''
      this.selectedSavedCard = payload
    }
  },
  watch: {
    showModal(val: boolean) {
      this.openModal = val
    }
  }
})
